var amdi18n={"__root":{"TIMELOOM_LOADING":"Loading video renderer...","TIMELOOM_ERROR_TITLE":"Video Renderer Error","TIMELOOM_INIT_FAILED":"Failed to initialize Timeloom renderer","TIMELOOM_NO_CONTENT":"No video content"},"__fr":{"TIMELOOM_LOADING":"Chargement du moteur vidéo...","TIMELOOM_ERROR_TITLE":"Erreur du moteur vidéo","TIMELOOM_INIT_FAILED":"Échec de l'initialisation du moteur Timeloom","TIMELOOM_NO_CONTENT":"Aucun contenu vidéo"},"__en":{"TIMELOOM_LOADING":"Loading video renderer...","TIMELOOM_ERROR_TITLE":"Video Renderer Error","TIMELOOM_INIT_FAILED":"Failed to initialize Timeloom renderer","TIMELOOM_NO_CONTENT":"No video content"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;